var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m457.974 377.184c20.379-35.738 32.03-77.099 32.03-121.184 0-135.311-109.691-245.002-245.002-245.002-69.179 0-131.652 28.682-176.203 74.791l70.578 291.395z",
    fill: "#49d88b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.3 484.212.933 3.85c24.721 8.388 51.213 12.94 78.769 12.94 31.511 0 61.629-5.954 89.299-16.79z",
    fill: "#1c2e7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.602 84.968h-62.424v335.071h-307.688v-335.071h-16.889c-43.059 44.152-69.601 104.488-69.601 171.032 0 76.902 35.442 145.517 90.87 190.435h365.731c13.688 0 24.824-11.136 24.824-24.824v-311.82c.001-13.687-11.136-24.823-24.823-24.823z",
    fill: "#167cc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.416 442.078c-3.038-5.326-1.868-10.866-.219-14.75 1.13-2.662.213-5.732-2.162-7.289h-94.545v-335.071h-16.889c-43.059 44.152-69.601 104.488-69.601 171.032 0 76.902 35.442 145.517 90.87 190.435h93.138c.352-1.441.183-2.998-.592-4.357z",
    fill: "#0e62a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.537 151.115v209.771c10.685 22.521 24.703 43.149 41.418 61.254h21.535v-272.326h-62.345c-.208.431-.402.869-.608 1.301z",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.178 149.814v272.326h62.424c.262 0 .528-.267.528-.528v-271.798z",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.537 151.115v.8h62.953v-42.651h-37.703c-9.744 13.008-18.214 27.022-25.25 41.851z",
    fill: "#1c2e7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.602 109.263h-62.424v42.651h62.952v-42.123c0-.261-.266-.528-.528-.528z",
    fill: "#2a428c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.463 445.642h-155.506v8.714c0 6.116-4.975 11.091-11.091 11.091h-195.065c-6.116 0-11.091-4.976-11.091-11.091v-8.714h-41.825c22.757 18.636 48.928 33.255 77.434 42.779h288.341c3.872 0 7.735-.51 11.446-1.614.02-.006.04-.012.06-.018l25.433-7.582c11.508-3.431 19.397-14.011 19.401-26.019.002-4.164-3.373-7.546-7.537-7.546z",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.805 467.031-.681-1.585h-85.323c-6.116 0-11.091-4.976-11.091-11.091v-8.714h-41.824c22.757 18.636 48.928 33.255 77.434 42.779h61.486c-11.187-11.186-.001-21.389-.001-21.389z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.125 445.642v8.714c0 6.971 5.704 12.676 12.676 12.676h195.065c6.972 0 12.676-5.704 12.676-12.676v-8.714z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.13 454.355v-8.714h-86.005v8.714c0 6.972 5.704 12.676 12.676 12.676h86.005c-6.972 0-12.676-5.704-12.676-12.676z",
    fill: "#bec8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.388 101.757 311.89 166.829v-202.649h-311.89z",
    fill: "#9bd8f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.388 101.757 95.038 50.835.795-31.611c.027-1.077-.238-2.141-.767-3.079l-.664-1.177c-.49-.87-1.182-1.618-2.039-2.13-20.251-12.125-14.435-35.461-11.608-43.64.578-1.672.335-3.474-.523-5.018h-80.232z",
    fill: "#73c3f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.388 99.657v322.482h311.89v-155.654z",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.145 198.404c1.382-1.096 2.198-2.747 2.242-4.51l1.091-43.374-95.09-50.863v322.482h98.587c-.521-.979-1.316-1.821-2.36-2.381-16.702-8.97-15.94-27.41-15.819-29.27.008-.122.011-.24.011-.363v-69.362-74.86c0-.846-.192-1.68-.533-2.455-10.66-24.274 5.73-40.173 11.871-45.044z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m221.353 260.374h-27.307c-4.35 0-7.877-3.526-7.877-7.877s3.527-7.877 7.877-7.877h27.307c4.35 0 7.877 3.526 7.877 7.877 0 4.35-3.526 7.877-7.877 7.877z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m221.353 290.569h-27.307c-4.35 0-7.877-3.526-7.877-7.877s3.527-7.877 7.877-7.877h27.307c4.35 0 7.877 3.526 7.877 7.877s-3.526 7.877-7.877 7.877z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m221.353 320.764h-27.307c-4.35 0-7.877-3.526-7.877-7.877s3.527-7.877 7.877-7.877h27.307c4.35 0 7.877 3.526 7.877 7.877s-3.526 7.877-7.877 7.877z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m221.353 350.959h-98.866c-4.35 0-7.877-3.526-7.877-7.877s3.527-7.877 7.877-7.877h98.866c4.35 0 7.877 3.526 7.877 7.877s-3.526 7.877-7.877 7.877z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m221.353 381.154h-98.866c-4.35 0-7.877-3.526-7.877-7.877s3.527-7.877 7.877-7.877h98.866c4.35 0 7.877 3.526 7.877 7.877s-3.526 7.877-7.877 7.877z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m301.635 381.154h-33.563c-4.837 0-8.758-3.921-8.758-8.758v-58.628c0-4.837 3.921-8.758 8.758-8.758h33.563c4.837 0 8.758 3.921 8.758 8.758v58.628c0 4.837-3.921 8.758-8.758 8.758z",
    fill: "#bec8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.808 320.764h-33.563c-4.837 0-8.758-3.921-8.758-8.758v-58.628c0-4.837 3.921-8.758 8.758-8.758h33.563c4.837 0 8.758 3.921 8.758 8.758v58.628c0 4.837-3.921 8.758-8.758 8.758z",
    fill: "#bec8f7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m358.18 381.154h-27.307c-4.35 0-7.877-3.526-7.877-7.877s3.527-7.877 7.877-7.877h27.307c4.35 0 7.877 3.526 7.877 7.877s-3.527 7.877-7.877 7.877z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m358.18 350.959h-27.307c-4.35 0-7.877-3.526-7.877-7.877s3.527-7.877 7.877-7.877h27.307c4.35 0 7.877 3.526 7.877 7.877s-3.527 7.877-7.877 7.877z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m358.18 320.764h-27.307c-4.35 0-7.877-3.526-7.877-7.877s3.527-7.877 7.877-7.877h27.307c4.35 0 7.877 3.526 7.877 7.877s-3.527 7.877-7.877 7.877z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m358.18 290.569h-98.866c-4.35 0-7.877-3.526-7.877-7.877s3.527-7.877 7.877-7.877h98.866c4.35 0 7.877 3.526 7.877 7.877s-3.527 7.877-7.877 7.877z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m358.18 260.374h-98.866c-4.35 0-7.877-3.526-7.877-7.877s3.527-7.877 7.877-7.877h98.866c4.35 0 7.877 3.526 7.877 7.877 0 4.35-3.527 7.877-7.877 7.877z",
    fill: "#bec8f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m385.399 23.58h-290.131c-6.009 0-10.88 4.871-10.88 10.88v33.578h311.89v-33.579c0-6.008-4.87-10.879-10.879-10.879z",
    fill: "#2a428c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.158 58.005c.697-1.024 1.109-2.214 1.109-3.453v-15.636c0-1.278-.399-2.536-1.177-3.55-2.835-3.692-1.833-6.921-.383-9.061.56-.827.852-1.767.919-2.724h-70.358c-6.009 0-10.88 4.871-10.88 10.88v33.579h80.973c-.128-.746-.384-1.476-.768-2.154-1.861-3.286-.551-6.242.565-7.881z",
    fill: "#1c2e7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.067 46.677c0 5.511-4.467 9.979-9.979 9.979-5.511 0-9.979-4.468-9.979-9.979s4.468-9.978 9.979-9.978c5.512 0 9.979 4.467 9.979 9.978z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.656 46.677c0 5.511-4.467 9.979-9.978 9.979s-9.979-4.468-9.979-9.979 4.468-9.978 9.979-9.978 9.978 4.467 9.978 9.978z",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.245 46.677c0 5.511-4.467 9.979-9.978 9.979s-9.979-4.468-9.979-9.979 4.468-9.978 9.979-9.978c5.51 0 9.978 4.467 9.978 9.978z",
    fill: "#38c674"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m299.217 54.554h-102.763c-4.35 0-7.877-3.527-7.877-7.877s3.527-7.877 7.877-7.877h102.763c4.35 0 7.877 3.527 7.877 7.877 0 4.351-3.526 7.877-7.877 7.877z",
    fill: "#3c58a0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m367.484 54.554h-9.221c-4.35 0-7.877-3.527-7.877-7.877s3.527-7.877 7.877-7.877h9.221c4.35 0 7.877 3.527 7.877 7.877 0 4.351-3.526 7.877-7.877 7.877z",
    fill: "#3c58a0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m335.429 54.554h-9.22c-4.35 0-7.877-3.527-7.877-7.877s3.527-7.877 7.877-7.877h9.22c4.35 0 7.877 3.527 7.877 7.877 0 4.351-3.526 7.877-7.877 7.877z",
    fill: "#3c58a0"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.333,
    cy: 196.818,
    fill: "#1c2e7a",
    rx: 62.344,
    ry: 18.171
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.333 178.647c-1.049 0-2.091.008-3.127.023-1.011 1.196-1.596 1.892-1.596 1.892s37.281 15.561 2.727 34.412c.664.006 1.326.015 1.995.015 34.432 0 62.344-8.135 62.344-18.171.001-10.036-27.911-18.171-62.343-18.171z",
    fill: "#142766"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m333.85 129.515-85.314-38.894c-5.21-2.375-11.194-2.375-16.404 0l-85.314 38.894c-7.911 3.607-7.911 14.845 0 18.452l32.683 14.9v-8.887c0-4.003 6.419-8.264 17.172-11.398 24.095-7.023 63.24-7.02 87.323 0 10.752 3.134 17.172 7.395 17.172 11.398v8.887l32.683-14.9c7.91-3.607 7.91-14.845-.001-18.452z",
    fill: "#3c58a0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m146.817 129.515c-7.911 3.607-7.911 14.845 0 18.452l32.683 14.9v-8.887c0-4.003 6.419-8.264 17.172-11.398 10.796-3.147 24.615-4.878 38.745-5.204 2.573-1.096 4.916-1.568 4.916-1.568-34.413-18.27-8.202-45.187-8.202-45.187z",
    fill: "#2a428c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.333 135.809c-34.432 0-62.344 8.135-62.344 18.171v42.838h.324c3.202-9.16 29.747-16.307 62.02-16.307s58.818 7.147 62.02 16.307h.324v-42.838c0-10.036-27.912-18.171-62.344-18.171z",
    fill: "#2a428c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.333 135.809c-34.432 0-62.344 8.135-62.344 18.171v42.838h.324c3.044-8.709 27.192-15.593 57.297-16.251v-.005c-6.948-2.678-6.807-9.779-6.807-9.779s0-20.005 0-26.333c0-6.327 11.53-8.641 11.53-8.641z",
    fill: "#1c2e7a"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m277.6 223.139c-4.558 0-8.253-3.695-8.253-8.253v-23.37c0-4.558 3.695-8.253 8.253-8.253s8.253 3.695 8.253 8.253v23.37c0 4.558-3.695 8.253-8.253 8.253z",
    fill: "#ffdd40"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m277.6 183.263c-4.558 0-8.253 3.695-8.253 8.253v20.804c0-4.558 3.695-8.253 8.253-8.253s8.253 3.695 8.253 8.253v-20.804c0-4.558-3.695-8.253-8.253-8.253z",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m277.6 178.677c-3.419 0-6.19-2.771-6.19-6.19v-73.017c0-3.419 2.771-6.19 6.19-6.19 3.418 0 6.19 2.771 6.19 6.19v73.017c0 3.419-2.772 6.19-6.19 6.19z",
    fill: "#ffdd40"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m289.309 182.491c0 6.466-5.242 11.708-11.708 11.708s-11.709-5.242-11.709-11.708c0-6.467 5.242-11.709 11.709-11.709 6.465.001 11.708 5.243 11.708 11.709z",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.803 180.188c0 2.964-2.403 5.367-5.367 5.367s-5.367-2.403-5.367-5.367 2.403-5.367 5.367-5.367 5.367 2.403 5.367 5.367z",
    fill: "#ffdd40"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.64629448.svg";
export { ForwardRef as ReactComponent };